var render = function () {
  var _this = this;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', {
    staticClass: "container--large"
  }, [_c('auction-program-header', _vm._b({
    model: {
      value: _vm.program,
      callback: function callback($$v) {
        _vm.program = $$v;
      },
      expression: "program"
    }
  }, 'auction-program-header', {
    _program: _vm._program
  }, false))], 1), _c('v-container', [_c('div', {
    staticClass: "tab-wrap"
  }, [_c('auction-program-groups', _vm._b({
    attrs: {
      "value": _vm.group
    }
  }, 'auction-program-groups', {
    program: _vm.program
  }, false))], 1), _c('div', [_c('auction-program-search', _vm._b({}, 'auction-program-search', {
    totalCount: _vm.totalCount
  }, false)), _c('auction-work-list', {
    staticClass: "gallery-card-row",
    attrs: {
      "works": _vm.works
    }
  })], 1), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    staticClass: "mt-8 mb-16",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _this.$route.query, {
            page: page
          })
        });
      }
    }
  })], 1)]), _c('v-fade-transition', {
    attrs: {
      "leave-absolute": ""
    }
  }, [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "color": "white",
      "light": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "indeterminate": "",
      "size": "100",
      "width": "5"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }